export const getMOTCheckerData = (numberOfDaysBeforeToRemind = '') => ({
  reminder: {
    eventDescription: `Just a reminder that your car's MOT is due in ${numberOfDaysBeforeToRemind} days from today. Please remember to book it in with your local test centre before the MOT expires.

Already booked it in or forgotten the details? Use the Auto Express MOT checker tool to check again.

This reminder is from the team at Auto Express.

https://www.autoexpress.co.uk/mot-history-check`,
    eventTitle: 'Car MOT reminder',
    text: `Remind me ${numberOfDaysBeforeToRemind} days before MOT`,
    tooltipInfo: `Download a calendar reminder for ${numberOfDaysBeforeToRemind} days before your MOT due date.`,
    filename: 'car-mot-reminder.ics',
    trackingData: {
      event: 'mot_checker.add_calendar',
      'mot.vrm': '[vrm]',
      'mot.make': '[make]',
      'mot.model': '[model]',
    },
  },
  contact: {
    text: 'If you think the MOT expiry date or any of the vehicle details are wrong, ',
    href: 'https://www.gov.uk/contact-dvsa/y/mot-vehicle-tests-and-approval',
    agency: 'DVSA',
  },
  regPlateTrackingData: {
    event: 'mot_checker.button_click',
    'mot.vrm': '[vrm]',
    'mot.vrm_valid': '[vrm-valid]',
    'mot.make': '[make]',
    'mot.model': '[model]',
  },
});

export const getTaxCheckerData = (numberOfDaysBeforeToRemind = '') => ({
  reminder: {
    eventDescription: `Just a reminder that your car's tax is due to expire ${numberOfDaysBeforeToRemind} days from today. Please remember to pay your tax via the https://www.gov.uk/vehicle-tax website before it expires.

    This reminder is from the team at Auto Express.
    
    https://www.autoexpress.co.uk/tax-checker`,
    eventTitle: 'Car tax reminder',
    text: `Remind me ${numberOfDaysBeforeToRemind} days before tax expires`,
    tooltipInfo: `Download a calendar reminder for ${numberOfDaysBeforeToRemind} days before your tax due date.`,
    filename: 'car-tax-reminder.ics',
    trackingData: {
      event: 'tax_checker.add_calendar',
      'tax.vrm': '[vrm]',
      'tax.make': '[make]',
      'tax.model': '[model]',
    },
  },
  contact: {
    text: 'If you think the tax expiry date or any of the vehicle details are wrong, ',
    href: 'https://contact.dvla.gov.uk/vehicle-tax',
    agency: 'DVLA',
  },
  regPlateTrackingData: {
    event: 'tax_checker.button_click',
    'tax.vrm': '[vrm]',
    'tax.vrm_valid': '[vrm-valid]',
    'tax.make': '[make]',
    'tax.model': '[model]',
  },
});
